// extracted by mini-css-extract-plugin
export var container = "DecklistWithMetaData-module--container--dfda4";
export var description = "DecklistWithMetaData-module--description--37794";
export var drafter = "DecklistWithMetaData-module--drafter--5ef90";
export var label = "DecklistWithMetaData-module--label--3833c";
export var metadata = "DecklistWithMetaData-module--metadata--c425a";
export var name = "DecklistWithMetaData-module--name--7ea4b";